module.exports = __webpack_public_path__ + "img/web-performance-before.2e80471b.png";